module.exports = __webpack_public_path__ + "static/media/18ECA3.d13b0870.jpg";